import { action, makeObservable, observable } from 'mobx';

import { DriveItemPreview } from '@/drive/entities/DriveItem/DriveItemPreview';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { PinnedItem } from '@/forwarding/entities/PinnedItem/PinnedItem';
import { createEmptyForm, ForwardForm } from '@/forwarding/types/ForwardForm';
import { ForwardInfo } from '@/forwarding/types/ForwardInfo';
import { GlobalAccessTarget } from '@/security/entities/GlobalAccessTarget';

export enum DriveItemType {
  Folder = 'folder',
  Collection = 'collection',
  CollectionSubscription = 'collectionSubscription',
  CarbonProject = 'carbonProject',
  Product = 'product',
  Url = 'url',
  Spectrum = 'spectrum',
}

export class BaseDriveItem {
  id!: DriveItemId;
  title!: string;
  type!: DriveItemType;
  description?: string;
  preview?: Nullable<DriveItemPreview>;
  canEdit!: boolean;
  canManageAccess!: boolean;
  createdAt?: string;
  updatedAt?: string;

  getLinkData?(): DriveItemLinkData;

  constructor() {
    makeObservable(this, {
      id: observable,
      title: observable,
      type: observable,
      description: observable,
      preview: observable,
      canEdit: observable,
      canManageAccess: observable,
      createdAt: observable,
      updatedAt: observable,
      setTitle: action,
      setDescription: action,
      setPreview: action,
    });
  }

  getDisplayTitle(): string {
    return this.title ?? '';
  }

  isContainer(): boolean {
    return false;
  }

  toPinnedItem(): Nullable<PinnedItem> {
    return null;
  }

  toGlobalAccessTarget(): Nullable<GlobalAccessTarget> {
    return null;
  }

  canBeShared(): boolean {
    return true;
  }

  canBeDuplicated(): boolean {
    return true;
  }

  canChangePreview(): boolean {
    return false;
  }

  canContainItem(item: BaseDriveItem): boolean {
    void item;

    return false;
  }

  toFormData(): ForwardForm {
    return {
      ...createEmptyForm(),
      title: this.title ?? '',
      description: this.description ?? '',
      previewUrl: this.preview?.url ?? '',
    };
  }

  toForwardInfo(): ForwardInfo {
    return {
      preview: this as ForwardInfo['preview'],
      ...this.toFormData(),
    };
  }

  setTitle(title: string) {
    this.title = title;
  }

  setDescription(description: string) {
    this.description = description;
  }

  setPreview(preview: Nullable<DriveItemPreview>) {
    this.preview = preview;
  }
}

export interface DriveItemLinkData {
  isExternal: boolean;
  url: string;
}
